import { IWorkflow } from "@/interfaces/workflow.interface";
import { WorkflowSaveDialogMessages } from "@/messages/workflow/workflow-save-dialog.messages";
import { SelectData } from "@/types/form.types";

export const ACTIVE_WORKFLOW_OPTIONS = (
  workflows: IWorkflow[],
  selectedTriggerType: number,
  messages: WorkflowSaveDialogMessages
): SelectData<number>[] => {
  if (selectedTriggerType === -1) {
    return [{ value: -1, label: messages.noWorkflowOption }];
  }

  return workflows
    .filter((w) => w.active && w.workflowTypeId === selectedTriggerType)
    .map((w) => {
      return { value: w.id, label: w.name };
    });
};
